import React, { useEffect, useRef } from "react";
import classes from "./Header.module.css";
import { Urls } from "../../Urls";
import {
  LinkedinShareButton,
  WhatsappShareButton,
  EmailShareButton,
  WhatsappIcon,
  LinkedinIcon,
  EmailIcon,
} from "react-share";
import { useMixPanelForTracking } from "../../shared_utilities/trackMixPanel";

const copyLink = (transporter_id, transporter_name, copyTextRef, TrackMixPanel) => {
  TrackMixPanel({
    ModuleName: "transporter profile",
    ScreenName: "header",
    Data: "none",
    Definition: "user has clicked on copy button",
  });

  navigator.clipboard
    .writeText(copyTextRef.current.value)
    .then(() => {
      alert("Link has been copied");
    })
    .catch((error) => {
      console.error("Failed to copy text: ", error);
      alert("Failed to copy link");
    });
};

export const ShareButton = ({
  transporter_id,
  transporter_name,
  transporter_code,
  onClose,
}) => {
  const inputRef = useRef(null);
  const { TrackMixPanel } = useMixPanelForTracking();

  useEffect(() => {
    TrackMixPanel({
      ModuleName: "transporter profile",
      ScreenName: "header",
      Data: "none",
      Definition: "user has clicked share button",
    });
  }, [transporter_id, transporter_name, TrackMixPanel]);

  return (
    <div
      style={{
        position: "absolute",
        top: "48px",
        right: "35px",
      }}
    >
      <div className={classes.overlay} onClick={onClose}></div>

      <div className={classes.userProfilePopup}>
        <div className={classes.linkContainer}>
          <input
            ref={inputRef}
            value={`https://portal.lorri.in/profile/${transporter_code}`}
            readOnly
            className={classes.profileUrlInput}
          />
          <button
            title="Copy Profile URL"
            onClick={() => copyLink(transporter_id, transporter_name, inputRef, TrackMixPanel)}
            className={`btn btn-sm m-0 p-2 ${classes.iconContainer}`}
          >
            <i className="fa fa-copy" />
          </button>
        </div>
        <div className={classes.userProfilePopupUserDetails}>
          <WhatsappShareButton
            title={`I am sharing you LoRRI Profile of ${transporter_name}, click to view profile: `}
            className="m-0"
            url={`https://portal.lorri.in/profile/${transporter_code}`}
            onClick={() =>
              TrackMixPanel({
                ModuleName: "transporter profile",
                ScreenName: "header",
                Data: "none",
                Definition: "user has clicked on whatsapp button",
              })
            }
          >
            <WhatsappIcon size={32} round={true} />
          </WhatsappShareButton>
          <LinkedinShareButton
            url={`https://portal.lorri.in/profile/${transporter_code}`}
            title="My LoRRI Profile"
            onClick={() =>
              TrackMixPanel({
                ModuleName: "header",
                ScreenName: "transporter-profile",
                Data: "none",
                Definition: "user has clicked on linkedin button",
              })
            }
          >
            <LinkedinIcon size={32} round={true} />
          </LinkedinShareButton>
          <EmailShareButton
            subject="I am sharing LoRRI Profile with you!"
            body={`Hi, I am sharing you LoRRI Profile of ${transporter_name}. You can view the same here: `}
            url={`https://portal.lorri.in/profile/${transporter_code}`}
            onClick={() =>
              TrackMixPanel({
                ModuleName: "transporter profile",
                ScreenName: "header",
                Data: "none",
                Definition: "user has clicked on email button",
              })
            }
          >
            <EmailIcon size={32} round={true} />
          </EmailShareButton>
        </div>
      </div>
    </div>
  );
};
